export default async (context) => {
  await context.store.dispatch('referral/setReferrals', context.query)
}
